/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { sectionAttachmentsDtoSchema } from "./sectionAttachmentsDtoSchema.ts";
import { sectionBusinessModelSectionDtoSchema } from "./sectionBusinessModelSectionDtoSchema.ts";
import { sectionCompetitionSectionDtoSchema } from "./sectionCompetitionSectionDtoSchema.ts";
import { sectionDecisionDtoSchema } from "./sectionDecisionDtoSchema.ts";
import { sectionFinancialsSectionDtoSchema } from "./sectionFinancialsSectionDtoSchema.ts";
import { sectionHeaderDtoSchema } from "./sectionHeaderDtoSchema.ts";
import { sectionInvestmentNeedSectionDtoSchema } from "./sectionInvestmentNeedSectionDtoSchema.ts";
import { sectionMarketSectionDtoSchema } from "./sectionMarketSectionDtoSchema.ts";
import { sectionProblemSectionDtoSchema } from "./sectionProblemSectionDtoSchema.ts";
import { sectionReportOverviewDtoSchema } from "./sectionReportOverviewDtoSchema.ts";
import { sectionRoadmapSectionDtoSchema } from "./sectionRoadmapSectionDtoSchema.ts";
import { sectionSlidesDtoSchema } from "./sectionSlidesDtoSchema.ts";
import { sectionSolutionSectionDtoSchema } from "./sectionSolutionSectionDtoSchema.ts";
import { sectionTeamSectionDtoSchema } from "./sectionTeamSectionDtoSchema.ts";
import { z } from "zod/v4";

export const pitchDeckReportDtoSchema = z.object({
  get overview() {
    return sectionReportOverviewDtoSchema.optional();
  },
  get header() {
    return sectionHeaderDtoSchema.optional();
  },
  get decision() {
    return sectionDecisionDtoSchema.optional();
  },
  get attachments() {
    return sectionAttachmentsDtoSchema.optional();
  },
  get slides() {
    return sectionSlidesDtoSchema.optional();
  },
  get problem() {
    return sectionProblemSectionDtoSchema.optional();
  },
  get solution() {
    return sectionSolutionSectionDtoSchema.optional();
  },
  get competition() {
    return sectionCompetitionSectionDtoSchema.optional();
  },
  get market() {
    return sectionMarketSectionDtoSchema.optional();
  },
  get businessModel() {
    return sectionBusinessModelSectionDtoSchema.optional();
  },
  get roadmap() {
    return sectionRoadmapSectionDtoSchema.optional();
  },
  get financials() {
    return sectionFinancialsSectionDtoSchema.optional();
  },
  get investmentNeed() {
    return sectionInvestmentNeedSectionDtoSchema.optional();
  },
  get team() {
    return sectionTeamSectionDtoSchema.optional();
  },
});
